// Custom, on-brand inline SVG illustrations for the Heliopolis marketing site.
// Palette: navy #0D1B2A, blue #377DD3/#245FAF, gold #F5C64D, cyan #0EA5E9, border #D7E3F2.

export const HeroScene = ({ className = "" }) => (
  <svg viewBox="0 0 520 480" className={className} role="img" aria-label="Global pharmaceutical cold-chain logistics" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hg-blue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#377DD3" />
        <stop offset="1" stopColor="#245FAF" />
      </linearGradient>
      <linearGradient id="hg-glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#EAF2FB" />
        <stop offset="1" stopColor="#CFE1F6" />
      </linearGradient>
      <radialGradient id="hg-globe" cx="0.35" cy="0.3" r="0.9">
        <stop offset="0" stopColor="#3C86DC" />
        <stop offset="1" stopColor="#1E4E92" />
      </radialGradient>
    </defs>

    {/* soft backdrop blob */}
    <path d="M70 120C70 60 150 18 250 30c120 14 210-20 230 70s-30 170-150 210S110 360 78 300 70 180 70 120Z" fill="#EAF2FB" opacity="0.7" />

    {/* globe with dispatch arcs */}
    <circle cx="178" cy="196" r="96" fill="url(#hg-globe)" />
    <g stroke="#9CC4EE" strokeWidth="1.4" opacity="0.6" fill="none">
      <ellipse cx="178" cy="196" rx="96" ry="38" />
      <ellipse cx="178" cy="196" rx="60" ry="96" />
      <ellipse cx="178" cy="196" rx="96" ry="96" />
      <path d="M90 170h176M86 220h184" />
    </g>
    {/* continents hint */}
    <g fill="#6FA8E0" opacity="0.85">
      <path d="M150 150c18-10 40-6 46 6s-6 22-24 24-30-4-34-14 2-12 12-16Z" />
      <path d="M188 210c14 2 30 14 24 26s-30 8-40-2-2-26 16-24Z" />
    </g>
    {/* dispatch arcs + nodes */}
    <g stroke="#F5C64D" strokeWidth="2.4" fill="none" strokeLinecap="round">
      <path d="M176 110C300 70 380 120 430 96" strokeDasharray="4 7" />
      <path d="M250 196C340 196 400 250 452 236" strokeDasharray="4 7" />
    </g>
    <circle cx="430" cy="96" r="7" fill="#F5C64D" />
    <circle cx="452" cy="236" r="7" fill="#F5C64D" />
    <circle cx="176" cy="110" r="6" fill="#fff" stroke="#245FAF" strokeWidth="2" />

    {/* cold-chain vial card */}
    <g transform="translate(300 250)">
      <rect x="0" y="0" width="190" height="150" rx="20" fill="#fff" stroke="#D7E3F2" strokeWidth="1.5" />
      <rect x="0" y="0" width="190" height="44" rx="20" fill="url(#hg-blue)" />
      <rect x="0" y="24" width="190" height="20" fill="url(#hg-blue)" />
      <text x="18" y="29" fontFamily="Inter, sans-serif" fontSize="14" fontWeight="700" fill="#fff">Cold-chain monitored</text>
      {/* vial */}
      <g transform="translate(26 60)">
        <rect x="6" y="0" width="22" height="10" rx="3" fill="#245FAF" />
        <path d="M8 10h18v58a9 9 0 0 1-18 0Z" fill="url(#hg-glass)" stroke="#9CC4EE" strokeWidth="1.3" />
        <path d="M8 44h18v24a9 9 0 0 1-18 0Z" fill="#8FC7F0" />
      </g>
      {/* temp gauge */}
      <g transform="translate(70 62)">
        <rect x="0" y="6" width="98" height="8" rx="4" fill="#E4EEF9" />
        <rect x="0" y="6" width="58" height="8" rx="4" fill="#0EA5E9" />
        <circle cx="58" cy="10" r="8" fill="#fff" stroke="#0EA5E9" strokeWidth="2.5" />
        <text x="0" y="40" fontFamily="Inter, sans-serif" fontSize="13" fontWeight="700" fill="#0D1B2A">+2°C — +8°C</text>
        <text x="0" y="60" fontFamily="Inter, sans-serif" fontSize="11" fill="#64748B">GDP compliant</text>
      </g>
    </g>

    {/* cargo plane */}
    <g transform="translate(360 60) rotate(-8)">
      <path d="M0 30l54-8 26-22 10 4-12 22 30-4 14-12 8 4-10 20 10 18-8 4-18-12-30 6-14 22-10-4 8-24-56 8Z" fill="url(#hg-blue)" />
    </g>
  </svg>
);

export const WarehouseArt = ({ className = "" }) => (
  <svg viewBox="0 0 440 340" className={className} role="img" aria-label="Temperature-controlled warehouse" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="wh-blue" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#377DD3" /><stop offset="1" stopColor="#245FAF" /></linearGradient>
    </defs>
    <path d="M40 90l180-56 180 56v18H40Z" fill="url(#wh-blue)" />
    <rect x="40" y="108" width="360" height="200" rx="10" fill="#fff" stroke="#D7E3F2" strokeWidth="1.6" />
    {/* shelving */}
    <g stroke="#D7E3F2" strokeWidth="1.5">
      <line x1="40" y1="170" x2="400" y2="170" /><line x1="40" y1="232" x2="400" y2="232" />
      <line x1="160" y1="108" x2="160" y2="308" /><line x1="280" y1="108" x2="280" y2="308" />
    </g>
    {/* boxes */}
    {[[70,128],[110,128],[190,128],[230,128],[310,128],[350,128],[70,190],[110,190],[310,190],[350,190],[190,190]].map(([x,y],i)=>(
      <g key={i} transform={`translate(${x} ${y})`}>
        <rect width="34" height="30" rx="4" fill={i%3===0?"#F5C64D":"#EAF2FB"} stroke="#9CC4EE" strokeWidth="1" />
        <line x1="0" y1="10" x2="34" y2="10" stroke="#9CC4EE" strokeWidth="1" />
      </g>
    ))}
    {/* cold badge */}
    <g transform="translate(300 250)">
      <circle cx="26" cy="26" r="26" fill="#0EA5E9" />
      <path d="M26 10v32M14 18l24 16M38 18L14 34" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

export const Divider = ({ className = "" }) => (
  <svg viewBox="0 0 1200 40" preserveAspectRatio="none" className={className} aria-hidden="true">
    <path d="M0 20 Q 300 0 600 20 T 1200 20" fill="none" stroke="#D7E3F2" strokeWidth="2" strokeDasharray="2 10" strokeLinecap="round" />
  </svg>
);
